import LoadingCircles from 'root/src/client/web/base/LoadingCircles'

export const DynamicImportPlaceholder = () => (
	<div style={{ display: 'flex', justifyItems: 'center', alignItems: 'center', width: '100%', height: '100%', margin: 10 }}>
		<LoadingCircles />
	</div>
)
